module.exports = __webpack_public_path__ + "2d0c708e026c7ed9b2efc0e75c557e0d.svg";